import FilterYear from './FilterYear.vue';
import FilterMonth from './FilterMonth.vue';
import FilterPeriod from './FilterPeriod.vue';
import FilterStatus from './FilterStatus.vue';
import FilterService from './FilterService.vue';
import FilterAuthor from './FilterAuthor.vue';
import FilterExecutor from './FilterExecutor.vue';
import FilterQuarter from './FilterQuarter.vue';
import FilterDay from './FilterDay.vue';
import FilterCategory from './FilterCategory.vue';
import FilterCity from './FilterCity.vue';
import FilterExpired from './FilterExpired.vue';
import FilterSecurityGroup from './FilterSecurityGroup.vue';
import FilterActivity from './FilterActivity.vue';
import FilterPriority from './FilterPriority.vue';

export default {
    FilterYear,
    FilterMonth,
    FilterPeriod,
    FilterStatus,
    FilterService,
    FilterAuthor,
    FilterExecutor,
    FilterExpired,
    FilterQuarter,
    FilterDay,
    FilterCategory,
    FilterCity,
    FilterSecurityGroup,
    FilterActivity,
    FilterPriority,
};
